export default "__VITE_ASSET__TN1U6e6o__"